import { FunctionComponent, memo } from 'react';
import { StoryCardEditorialContent } from '../../../../services';
import { CardContainer } from '../CardContainer';
import { Content } from '../Content';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

export const Editorial: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const { content } = card;
  const { headline, subHeadline, sourceName, textHTML } = content as StoryCardEditorialContent;

  return (
    <CardContainer card={card}>
      <Content source={sourceName} title={headline} subTitle={subHeadline} htmlText={textHTML} />
    </CardContainer>
  );
});
